import { render, staticRenderFns } from "./serviceuserlist.vue?vue&type=template&id=372df743&scoped=true&"
import script from "./serviceuserlist.vue?vue&type=script&lang=js&"
export * from "./serviceuserlist.vue?vue&type=script&lang=js&"
import style0 from "./serviceuserlist.vue?vue&type=style&index=0&id=372df743&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372df743",
  null
  
)

export default component.exports